import BookItem from "../common/bookItem";
import { mouseEvent } from "../common/mouse_event";
import Visibility from "../common/visibility";
export default class AfileVideo extends BookItem {
    /**
     *
     * @type {Visibility}
     * @memberof JumpPage
     */
    visibilityComponent = null;
    constructor(el, target) {
        super(el, target);
        this.connectNumber = el.connectNumber;  //連接ShowHide開關
        this.fileName = el.fileName;

        mouseEvent.add_mouse_event(this);
    }

    init() {
        super.init();
        this.target.gotoAndStop(0);
        this.target.visible = false;
        this.visibilityComponent = new Visibility(this.target, this, this.itemControl);
    }

    start() {
        this.visibilityComponent.setVisibleByGroup();
    }

    trigger() {
        window.aFileControl.openMovie(this.fileName);
    }
}